module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Itallic-e9b5046d155a333f5fb9508ee131f1ad7aefe18fb87d34d012c49dab7347fcf6.svg";